const surveyFieldIdMap = {
    name: process.env.INFOGRAPHIC_SURVEY_NAME,
    city: 'cons_city',
    state: 'cons_state',
    country: 'cons_country',
    email: 'cons_email',
    role: process.env.INFOGRAPHIC_SURVEY_ROLE,
    whoDoYouWalkFor: process.env.INFOGRAPHIC_SURVEY_WHO_DO_YOU_WALK_FOR,
    whyDoYouWalk: process.env.INFOGRAPHIC_SURVEY_WHY_YOU_WALK,
    fundraisingGoal: process.env.INFOGRAPHIC_SURVEY_FUNDRAISING_GOAL,
    favoriteWay: process.env.INFOGRAPHIC_SURVEY_FAVORITE_WAY,
    supporterSince: process.env.INFOGRAPHIC_SURVEY_SUPPORTER_SINCE,
    difference: process.env.INFOGRAPHIC_SURVEY_DIFFERENCE,
    // name: '954_33516_1_55290',
    // city: 'cons_city',
    // state: 'cons_state',
    // country: 'cons_country',
    // email: 'cons_email',
    // role: '954_33516_3_55292',
    // whoDoYouWalkFor: '954_33516_4_55293',
    // whyYouWalk: '954_33516_5_55294',
    // fundraisingGoal: '954_33516_6_55295',
    // favoriteWay: '954_33516_7_55296',
    // supporterSince: '954_33516_8_55297',
    // difference: '954_33516_9_55298',
  };
  
  window.onscroll = function() {
    const intViewportWidth = window.innerWidth;
    const fixedInfographic = document.getElementById('infographic-container');
    if (intViewportWidth > 600) {
      if (document.body.scrollTop + document.documentElement.scrollTop > 200) {
        fixedInfographic.classList.add('fixed');
      } else {
        fixedInfographic.classList.remove('fixed');
      }
    }
  };
  
  const $nameInputField = document.getElementById('fullName');
  const $cityInputField = document.getElementById('city');
  const $emailInputField = document.getElementById('emailAddress');
  const $fundraisingGoalInputField = document.getElementById('fundraisingGoal');
  const $countrySelectField = document.querySelector('#country-select select');
  const $stateSelectField = document.querySelector('#state-select select');
  const $roleSelectField = document.getElementById('role');
  const $whoYouWalkForSelectField = document.getElementById('whoDoYouWalkFor');
  const $whyYouWalkSelectField = document.getElementById('whyYouWalk');
  const $favoriteWaySelectField = document.getElementById('favoriteWay');
  const $feelSelectField = document.getElementById('feel');
  const $yearInputField = document.getElementById('year');
  const $createButton = document.getElementById('create-you-graphic');
  const $changesButton = document.getElementById('make-changes');
  const $submitButton = document.getElementById('submit-graphic');
  
  $prePopulateFields = (() => {
    const cityStateElement = document.querySelector('.city-state-container');
    const value = $countrySelectField.options[$countrySelectField.selectedIndex].value;
    cityStateElement.style.display = value === 'United States' ? 'block' : 'none';
    const htmlForCityState = '<span id="city-container"></span><span id="state-container"></span>';
    document.getElementById('city-state-container').innerHTML = value !== 'United States' ? value : htmlForCityState;
    if (value.length > 14) {
      document.getElementById('city-state-container').classList.add('smaller');
    } else {
      document.getElementById('city-state-container').classList.remove('smaller');
    }
    if ($nameInputField.value.length) {
      document.getElementById('full-name-container').textContent = $nameInputField.value;
    }
    if ($cityInputField.value !== '') {
      document.getElementById('city-container').textContent = $cityInputField.value;
      if ($stateSelectField.value !== '') {
        document.getElementById('state-container').textContent = ', ' + $stateSelectField.value ;
      }
    } else {
      if ($stateSelectField.value !== '') {
        document.getElementById('state-container').textContent = $stateSelectField.value ;
      }
    }
  })();
  
  const validateFields = () => {
    const requiredFields = ['fullName', 'country-select', 'role', 'fundraisingGoal', 'favoriteWay', 'year', 'feel', 'emailAddress'];
    const formFields = document.getElementById('infographicForm').elements;
    let isInvalid = false;
    Object.keys(formFields).map(field => {
      const id = formFields[field].id;
      const value = formFields[field].value;
      isInvalid = requiredFields.includes(id) && value === '';
    });
  
    if (!isInvalid) {
      if ($countrySelectField.options[$countrySelectField.selectedIndex].value === 'United States') {
        const city = $cityInputField.value;
        const state = $stateSelectField.options[$stateSelectField.selectedIndex].value;
        isInvalid = city === '' || state === '';
      }
    }
    if (!isInvalid) {
      const role = $roleSelectField.options[$roleSelectField.selectedIndex].value;
      if (role === 'Pediatric' || role === 'Patient') {
        isInvalid = $whoYouWalkForSelectField.options[$whoYouWalkForSelectField.selectedIndex].value === '';
      } else {
        isInvalid = $whyYouWalkSelectField.options[$whyYouWalkSelectField.selectedIndex].value === '';
      }
    }
    return isInvalid;
  };
  
  $nameInputField.addEventListener('keyup', () => {
    document.getElementById('full-name-container').textContent = $nameInputField.value;
  });
  
  $countrySelectField.addEventListener('change', () => {
    const cityStateElement = document.querySelector('.city-state-container');
    const value = $countrySelectField.options[$countrySelectField.selectedIndex].value;
    cityStateElement.style.display = value === 'United States' ? 'block' : 'none';
    const htmlForCityState = '<span id="city-container"></span><span id="state-container"></span>';
    document.getElementById('city-state-container').innerHTML = value !== 'United States' ? value : htmlForCityState;
    if (value.length > 14) {
      document.getElementById('city-state-container').classList.add('smaller');
    } else {
      document.getElementById('city-state-container').classList.remove('smaller');
    }
  });
  
  $cityInputField.addEventListener('keyup', () => {
    document.getElementById('city-container').textContent = $cityInputField.value;
    if ($cityInputField.value !== '') {
      if ($stateSelectField.value !== '') {
        document.getElementById('state-container').textContent = ', ' + $stateSelectField.value ;
      }
    } else {
      document.getElementById('state-container').textContent = $stateSelectField.value ;
    }
  });
  
  $stateSelectField.addEventListener('change', () => {
    const text = $stateSelectField.options[$stateSelectField.selectedIndex].text.split(' -')[0];
    document.getElementById('state-container').innerHTML = ', ' + text;
  });
  
  $roleSelectField.addEventListener('change', () => {
    document.getElementById('why-container').innerHTML = '';
    const value = $roleSelectField.options[$roleSelectField.selectedIndex].value;
    document.getElementById(
      'role-container'
    ).innerHTML = `<img src="../p2p-ui-framework/${infographicGlobals.devBranch}dist/img/programs/walk-run/infographic/${infographicGlobals.locale}/Role-${value}.png" />`;
    document.getElementById('whoDoYouWalkFor').value = "";
    document.getElementById('whyYouWalk').value = "";
    if (value === 'Pediatric' || value === 'Patient') {
      document.getElementById('who-do-you-walk-for').style.display = 'block';
      document.getElementById('why-do-you-walk').style.display = 'none';
    } else {
      document.getElementById('why-do-you-walk').style.display = 'block';
      document.getElementById('who-do-you-walk-for').style.display = 'none';
    }
  });
  
  $whyYouWalkSelectField.addEventListener('change', () => {
    const value = $whyYouWalkSelectField.options[$whyYouWalkSelectField.selectedIndex].value;
    document.getElementById(
      'why-container'
    ).innerHTML = `<img src="../p2p-ui-framework/${infographicGlobals.devBranch}dist/img/programs/walk-run/infographic/${infographicGlobals.locale}/TopLeft-${value}.png" />`;
  });
  
  $whoYouWalkForSelectField.addEventListener('change', () => {
    const value = $whoYouWalkForSelectField.options[$whoYouWalkForSelectField.selectedIndex].value;
    document.getElementById(
      'why-container'
    ).innerHTML = `<img src="../p2p-ui-framework/${infographicGlobals.devBranch}dist/img/programs/walk-run/infographic/${infographicGlobals.locale}/TopLeft-${value}.png" />`;
  });
  
  $favoriteWaySelectField.addEventListener('change', () => {
    const value = $favoriteWaySelectField.options[$favoriteWaySelectField.selectedIndex].value;
    document.getElementById(
      'favorite-way-container'
    ).innerHTML = `<img src="../p2p-ui-framework/${infographicGlobals.devBranch}dist/img/programs/walk-run/infographic/${infographicGlobals.locale}/TopRight-${value}.png" />`;
  });
  
  $feelSelectField.addEventListener('change', () => {
    const value = $feelSelectField.options[$feelSelectField.selectedIndex].value;
    document.getElementById(
      'feel-container'
    ).innerHTML = `<img src="../p2p-ui-framework/${infographicGlobals.devBranch}dist/img/programs/walk-run/infographic/${infographicGlobals.locale}/BottomRight-${value}.png" />`;
  });
  
  $fundraisingGoalInputField.addEventListener('keyup', () => {
    const fundraisingGoalText = document.getElementById('fundraising-goal-text');
    fundraisingGoalText.style.display = $fundraisingGoalInputField.value !== '' ? 'block' : 'none';
    const value = $fundraisingGoalInputField.value.replace(/$/g, '').replace(/,/g, '');
    const formattedGoal = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    $fundraisingGoalInputField.value = formattedGoal;
    document.getElementById('fundraising-goal-container').textContent = `$${formattedGoal}`;
  });
  
  $yearInputField.addEventListener('keyup', () => {
    document.getElementById(
      'bottom-left'
    ).style.backgroundImage = `url("../p2p-ui-framework/${infographicGlobals.devBranch}dist/img/programs/walk-run/infographic/${infographicGlobals.locale}/BottomLeft-Date.png")`;
    document.getElementById('year-container').textContent = $yearInputField.value;
    //document.getElementById('i-heart-stj').style.display = 'block';
  });
  
  $createButton.addEventListener('click', () => {
    const isInvalid = validateFields();
    if (isInvalid) {
      document.getElementById('all-fields-required').style.display = 'block';
    } else {
      document.getElementById('all-fields-required').style.display = 'none';
      document.getElementById('infographic-form').style.display = 'none';
      document.getElementById('confirm-section').style.display = 'block';
    }
  });
  
  $changesButton.addEventListener('click', () => {
    document.getElementById('infographic-form').style.display = 'block';
    document.getElementById('confirm-section').style.display = 'none';
  });
  
  $submitButton.addEventListener('click', () => {
    const infoGraphic = document.getElementById('infographic-container');
    html2canvas(infoGraphic, {
      allowTaint: true,
      logging: true,
      taintTest: false,
      onrendered: function(canvas) {
        document.body.appendChild(canvas);
        jQuery('canvas').attr('id', 'infographic-canvas');
        localStorage.clear();
        localStorage.setItem('infographic-canvas', canvas.toDataURL());
        document.getElementById('confirm-section').style.display = 'none';
        document.getElementById('download-or-post').style.display = 'block';
      },
    });

    setTimeout(() => {
      document.getElementById('infographic-canvas').style.display = 'none';
    }, 1000);
  });
  
  const downloadGraphic = () => {
    const canvas = document.getElementById('infographic-canvas');
    canvas.toBlob(function(blob) {
      saveAs(blob, 'graphic.png');
    });
    setTimeout(() => {
      handleSubmitSurvey();
    }, 1000);
  };
  document.getElementById('download-graphic').addEventListener('click', downloadGraphic, false);
  
  const handleSubmitSurvey = () => {
    Object.keys(surveyFieldIdMap).map(field => {
      const input = document.getElementById(`${surveyFieldIdMap[field]}`);
      let value;
      switch (field) {
        case 'name':
          console.log("name submitted");
          input.value = $nameInputField.value;
          break;
        case 'city':
          console.log("city submitted");
          input.value = $cityInputField.value;
          break;
        case 'state':
          console.log("state submitted");
          value = $stateSelectField.options[$stateSelectField.selectedIndex].value;
          input.value = value;
          break;
        case 'country':
          console.log("country submitted");
          value = $countrySelectField.options[$countrySelectField.selectedIndex].value;
          input.value = value;
          break;
        case 'email':
          console.log("email submitted");
          input.value = $emailInputField.value;
          break;
        case 'role':
          console.log("role submitted");
          value = $roleSelectField.options[$roleSelectField.selectedIndex].value;
          input.value = value;
          break;
        case 'whoDoYouWalkFor':
          console.log("who you walk for submitted", $whoYouWalkForSelectField.value);
          if ($whoYouWalkForSelectField.value && $whoYouWalkForSelectField.value != '') {
            value = $whoYouWalkForSelectField.options[$whoYouWalkForSelectField.selectedIndex].value;
            input.value = value;
          }
          break;
        case 'whyDoYouWalk':
          console.log("why you walk submitted", $whyYouWalkSelectField.value);
          value = $whyYouWalkSelectField.options[$whyYouWalkSelectField.selectedIndex].value;
          input.value = value;
          break;
        case 'fundraisingGoal':
          console.log("goal submitted");
          input.value = $fundraisingGoalInputField.value;
          break;
        case 'favoriteWay':
          console.log("favorite way submitted");
          value = $favoriteWaySelectField.options[$favoriteWaySelectField.selectedIndex].value;
          input.value = value;
          break;
        case 'supporterSince':
          console.log("support since submitted");
          input.value = $yearInputField.value;
          break;
        case 'difference':
          console.log("difference submitted");
          value = $feelSelectField.options[$feelSelectField.selectedIndex].value;
          input.value = value;
          break;
      }
    });
    document.getElementById('ACTION_SUBMIT_SURVEY_RESPONSE').click();
  };
  
  if (document.getElementById('new-graphic')) {
    document.getElementById('new-graphic').addEventListener('click', () => {
      let url = window.location.pathname.split('/');
      url = window.location.origin + url[0] + '/' + url[1] + '/' + url[2] + '/PageServer?pagename=walk_infographic';
      window.location = url;
    });
  }